import { Component, OnInit, ChangeDetectorRef, OnDestroy, AfterViewInit } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';

import { AuthenticationService } from 'src/app/core/services/auth.service';
import { SpinnerService } from '../../core/services/spinner.service';
import { AuthGuard } from 'src/app/core/guards/auth.guard';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { KeycloakAuthorizationService } from 'src/app/auth/keycloak.authorization.service';
import { KeycloakProfile } from 'keycloak-js';
import { LicenseManager } from 'src/app/core/models/data/LicenseManager';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.css'],
    standalone: false
})
export class LayoutComponent implements OnInit, OnDestroy, AfterViewInit {

    selectedLanguage:string = "sk";
    selectedLanguageLabel:string = "en";

    private _mobileQueryListener: () => void;
    mobileQuery: MediaQueryList;
    showSpinner: boolean = false;

    firstName? : string;
    lastName? : string;
    email? : string;
    username? : string;

    isAdmin: boolean = false;

    private autoLogoutSubscription: Subscription = new Subscription;

    currentRoute: string = "";
    
    constructor(
        private changeDetectorRef: ChangeDetectorRef,
        private media: MediaMatcher,
        public spinnerService: SpinnerService,
        private translate: TranslateService,
        private keycloakService: KeycloakAuthorizationService,
        private router: Router,
        private licenseManager: LicenseManager
    ) {

        this.mobileQuery = this.media.matchMedia('(max-width: 1000px)');
        this._mobileQueryListener = () => changeDetectorRef.detectChanges();
        // tslint:disable-next-line: deprecation
        this.mobileQuery.addListener(this._mobileQueryListener);

        this.router.events.subscribe(() => {
            this.currentRoute = this.router.url;
        });

        this.licenseManager.initialize();
    }

    ngOnInit(): void {
        var lang = window.localStorage.getItem('languagePreference');
        if(lang !== null){
            this.selectedLanguage = lang;
            this.selectedLanguageLabel = lang === 'sk' ? 'en' : 'sk'
        }
        this.selectedLanguage = this.selectedLanguage === 'sk' ? 'en' : 'sk'; 

        this.keycloakService.loadUserProfile().then(profile => {
            this.firstName = profile.firstName;
            this.lastName = profile.lastName;
            this.email = profile.email;
            this.username = profile.username;
        });
    }

    // Logout function to log the user out of Keycloak
    logout() {
        this.keycloakService.logout();
    }

    openProfile(){
        this.router.navigate(['/profile']);
    }
    ngOnDestroy(): void {
        // tslint:disable-next-line: deprecation
        this.mobileQuery.removeListener(this._mobileQueryListener);
        this.autoLogoutSubscription.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.changeDetectorRef.detectChanges();
    }

    switchLanguage() {
        // Toggle between Slovensky and English
        if(this.selectedLanguageLabel === "en"){
            this.selectedLanguage = "en";
            this.selectedLanguageLabel = "sk";

        }
        else if(this.selectedLanguageLabel === "sk"){
            this.selectedLanguage = "sk";
            this.selectedLanguageLabel = "en";
        }
        this.translate.use(this.selectedLanguage);
        window.localStorage.setItem('languagePreference', this.selectedLanguage);
    }

    onClickGoToTspDashboard = this._onClickGoToTspDashboard.bind(this)

    _onClickGoToTspDashboard(){
        window.location.href = environment.tspDashboardUrl;
    }
}
